<template lang="pug">
.add-gym-consent
  Checkbox#gym-terms-checkbox(:modelValue="agree" :required="true" @update:modelValue="$emit('updateConsent', $event)")
    span {{ __('I agree to the') }}&nbsp;
    span.link(@click.stop.prevent="showMapNotice = true") {{ __('Rogue Equipped Gyms Map Notice') }}
    span .
  Modal(v-if="showMapNotice" @close="showMapNotice = false")
    .modal-content
      h2.center {{ __('Rogue Equipped Gyms Map Notice') }}
      p {{ __('By adding your gym to the Rogue Equipped Gyms Map, you acknowledge and agree that:') }}
      p {{ __('If you\'re an affiliate, training, or commercial gym owner and checked "Share Address", you consent to publicly display your gym\'s address and any other information you provide.') }}
      p {{ __('If you\'re a home gym owner or did not check "Share Address", your exact address will remain private, showing only the ZIP code, city, and country on the map.') }}
      p {{ __('Any data or media you submit (including adresses or photos) may be used or modified by Rogue Fitness for lawful purposes, and is treated as non-confidential and non-proprietary.') }}
      p {{ __('Rogue Fitness may remove or change your content, and may alter or discontinue the Rogue Equipped Gyms Map at its sole discretion.') }}
      p {{ __('By submitting any data or images you are representing and warranting to Rogue that you that you are the lawful copyright holder or licensee of the data or images and have full rights to grant Rogue the right to publish such data or images.') }}
      RogueButton(@click="acknowledge" color="black" width="full" text="Acknowledge")
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  agree: boolean,
  type: string,
}>()

const emit = defineEmits<{(e: 'updateConsent', val: boolean): void }>()

const showMapNotice = ref(false)

function acknowledge() {
  emit('updateConsent', true)
  showMapNotice.value = false
}

</script>

<style lang="scss" scoped>
:deep(.modal-container) {
  max-height: 100vh;
  overflow-y: auto;
}
.modal-content {
  padding: 0 $space-m;
}
</style>
